import React, {PropsWithChildren} from "react";
import styles from "./Center.module.css";

/**
 * Horizontally center children based on their intrinsic width.
 */
export function Center({children}: PropsWithChildren) {
	return <div className={styles.center}>{children}</div>;
}
